import './ai-loader.less'
import cx from 'classnames'

interface AiLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  fullscreen?: boolean
}

const AiLoader: React.FC<AiLoaderProps> = ({ className, fullscreen = false, ...props }) => (
  <div
    className={cx('ai-loader', { 'ai-loader--fullscreen': fullscreen }, className)}
    role='status'
    aria-label='Loading'
    {...props}
  >
    <div className='ai-loader__track'>
      <div className='ai-loader__ring' />
      <div className='ai-loader__core' />
    </div>
  </div>
)

export default AiLoader
